import { ProjectCreateCustomForm } from '../ui-components';
import { View, Button } from '@aws-amplify/ui-react';
import { useState } from 'react';
import { generateClient } from 'aws-amplify/api';
import { createProject } from '../graphql/mutations';
import { useNavigate } from 'react-router-dom';
import JustAdminMessage from '../commons/JustAdminMessage';

const client = generateClient();

function CreateProjectForm(props) {
  const [formData, setFormData] = useState();
  const [showForm, setShowForm] = useState(true);

  const navigate = useNavigate();
  const handleProjectPage = () => {
    navigate("/admin")
  }

  const OnChangeForm = (fields) => {
    setFormData(fields);
  };

  const OnValidateForm = {
    path: (value, validationResponse) => {
      const firstWord = value.split('')[0];
      if (firstWord !== '/') {
        return {
          hasError: true,
          errorMessage: 'Path must start with /'
        };
      }
      if (value.includes(" ")) {
        return {
          hasError: true,
          errorMessage: 'Path must not have spaces'
        };
      }
      return validationResponse;
    }
  };

  const OnSubmitForm = async () => {
    try {
      const newProject = await client.graphql({
        query: createProject,
        variables: {
          input: {
            ...formData,
            mapping: {}
          }
        }
      });

      console.log("Project created successfully");
      setShowForm(false);
      return newProject;
    } catch (error) {
      console.error("Error creating project:", error);
      throw error;
    }
  };

  return (
    <>
      {props.role === 'Administrador' ? (
        <View style={formStyle} font="font.inverse">
              {showForm ? (
        <>
          <h4>Create a new project</h4>
          <ProjectCreateCustomForm
            onChange={(fields) => OnChangeForm(fields)}
            onValidate={OnValidateForm}
            onCancel={handleProjectPage}
            onSubmit={OnSubmitForm}
          />        
          </>
      ) : (
        <>
          <h4>Proyecto creado correctamente</h4>
          <Button 
            padding='0.5rem'
            margin='1rem'
            variation="primary"
            onClick={() => { setShowForm(true); }}
            >Crear otro proyecto</Button>
          <Button 
            padding='0.5rem'
            margin='1rem'
            variation="primary"
            onClick={handleProjectPage}
            >Projects</Button>
        </>
      )}
        </View>

      ) : (
        <JustAdminMessage/>
      ) }

    </>
  );
}

const formStyle = {
  // padding: '50px 20px',
  backgroundColor: '#282c34',
  padding: '1rem',
  // width: '40rem',
  height: '30rem',
  color: 'white'
};

export default CreateProjectForm;
